export default class Company{
    constructor(name="",category="",ruc="",address="",ubigeo="",razon_social="",description=""){
        this.name=name;
        this.category=category;
        this.ruc=ruc;
        this.address=address;
        this.description = description
        this.ubigeo=ubigeo;
        this.razon_social=razon_social;
    }
}